import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { MasterLayout } from "src/MainLayout/LayoutMain";
import { LoadingPage } from "src/Pages/components/LoadingAnimation/LoadingPage";
import { BasePagePublic } from "../Pages/TelasLogin/BasePagePublic";
import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { LandingPages } from "src/Pages/components/LandingPages";
import { PublicRoutes } from "./PublicRoutes";
import { UrlConfigPublic } from "./Config/UrlConfigPublic";
import { getToken } from "src/shared/setup/API/api";
import { UrlConfig } from "src/shared/Utils/paths";

export function PrivateRoute() {
  const { authorization, loading } = useAuthContext();

  if (loading) {
    return <LoadingPage />;
  }
  return authorization ? <Outlet /> : <Navigate to={UrlConfigPublic.login} />;
}

export function PublicRoute() {
  const { authorization } = useAuthContext();
  return authorization ? <Navigate to="/dashboard" /> : <Outlet />;
}

export const RoutesMain = () => {
  const { loading, authorization, RefreshSession } = useAuthContext();
  const navigate = useNavigate();

  // pegar o token da url e setar no localStorage
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  if (token) {
    localStorage.setItem(getToken, token);
    RefreshSession();
    navigate(UrlConfig.dashboard.url);
  }

  if (loading && authorization) return <LoadingPage />;

  const { pathname } = useLocation();

  const isLandingPage = pathname.startsWith("/landing-page/");

  return isLandingPage ? (
    <Routes>
      <Route
        path="/landing-page/:idLandingPage/:idTenant"
        element={<LandingPages />}
      />
    </Routes>
  ) : (
    <Routes>
      {/* {authorization ? ( */}
      <Route element={<PrivateRoute />}>
        <Route element={<MasterLayout />}>{PrivateRoutes()}</Route>
      </Route>
      {/* // ) : ( */}
      <Route path="/" element={<BasePagePublic />}>
        {PublicRoutes()}
      </Route>
      {/* // )} */}
    </Routes>
  );
};
